﻿'use strict';
/**
 * trace service module.
 - traceService is a nice Angular-esque wrapper around the * stackTrace.js printStackTrace() method.
**/

var stackTrace = require('stacktrace-js');


// @ngInject 
module.exports = function(){ 

    return ({
        print: stackTrace
    });
}



